import { TypographyHeading } from "shared/molecules/typography-layout";
import { Box, InputLabel, Paper, FormControl, Select, MenuItem, Pagination, Button } from "@mui/material";
import Loader from "pages/build-test/loader";
import SectionTable from "shared/organisms/tables/table";
import { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import NoDataFound from "shared/molecules/no-data";
import { Stack } from "@mui/material"
import { table } from "./helper"
import liveClassClientService from "utils/graphql/liveclassClient";
import { GET_SESSION_ALLOCATIONS } from "utils/graphql/services/live-classes/queries";
import { useLocation } from "react-router-dom";
import { utcToIst } from "utils/time-util/utcIstTime";
import { SessionAllocationFilter } from "./filter";
import CollapsibleTable from "shared/organisms/tables/collapsible-table";


export default function AllocatedSession() {

    const location: any = useLocation();
    const liveSessionId = location?.state?.row?.liveSessionId || null;
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);


    const [searchPayload, setSearchPayload] = useState({});
    const [getSessionAllocationsList, { loading, error, data }] = useLazyQuery(
        GET_SESSION_ALLOCATIONS,
        {
            client: liveClassClientService,
        },
    );

    useEffect(() => {
        if (!liveSessionId) return;
        console.log("liveSessionId", liveSessionId);
        getSessionAllocationsList({
            variables: {
                input: {
                    limit: limit,
                    offset: (page - 1) * limit,
                    liveSessionId: liveSessionId,
                    ...searchPayload
                },
            },
        });
    }, [page, limit, searchPayload, liveSessionId]);

    const sessionAllocationData =
        data?.getSessionAllocations?.sessionAllocations?.map((item: any) => ({
            ...item,
            bufferedStartTime: utcToIst(item.bufferedStartTime),
            bufferedEndTime: utcToIst(item.bufferedEndTime),
            actualStartTime: utcToIst(item.actualStartTime),
            actualEndTime: utcToIst(item.actualEndTime),
            createdAt: utcToIst(item.createdAt),
            updatedAt: utcToIst(item.updatedAt),
            vendorUser: item?.vendorUser?.email || "-",
        })) || [];

    return (
        <>
            <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "25px" }}>
                Liveclass Session Allocations{" "}
            </TypographyHeading>

             <SessionAllocationFilter
                setSearchPayload={setSearchPayload}
                setPage={setPage}
            />

            <Paper elevation={2} sx={{ p: 2, mt: 3 }}>

                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                    <FormControl size="small" sx={{ width: 140 }}>
                        <InputLabel>Show Entries</InputLabel>
                        <Select
                            value={limit}
                            label="Show Entries"
                            onChange={(e) => {
                                setLimit(Number(e.target.value));
                                setPage(1); // reset to first page
                            }}
                        >
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                            <MenuItem value={500}>500</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <div>
                    {loading && <Loader />}
                    {!loading && data?.getSessionAllocations?.sessionAllocations?.length > 0 ? (
                        <CollapsibleTable
                            data={sessionAllocationData || []}
                            table={table}
                            id="id"
                            name="id"
                            rowsPerPageCount={limit}
                            style="false"
                            totalRecords={data?.getSessionAllocations?.totalCount || 0}
                            paginationSegmentApi="false"
                            viewSecondaryData="false"
                            showPaginationFooter={false}
                        />
                    ) : (
                        <div>{!loading && <NoDataFound message="No Data Found" />}</div>
                    )}
                </div>

                <Box sx={{ marginTop: "20px" }}>
                    <Stack
                        direction="row"
                        spacing={2}
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Pagination
                            count={Math.ceil(data?.getSessionAllocations?.totalCount / limit) || 1}
                            page={page}
                            onChange={(e, value) => setPage(value)}
                            color="primary"
                            size="medium"
                        />
                    </Stack>
                </Box>

            </Paper>
        </>
    )
}
